import React, { Fragment, useEffect } from "react";
import { menuItems } from "./../MenuItems";
import Widget from "components/widget/Widget";
import { useDispatch } from "react-redux";
import {
  setBreadCrumbs,
  setSelectedSubMenu,
  setSubHeader,
} from "features/navigation/NavigationSlice";

export default function PayrollOverview() {
  let dispatch = useDispatch();

  useEffect(() => {
    dispatch(setSelectedSubMenu(menuItems[0]));
    dispatch(setSubHeader("Overview"));
    dispatch(
      setBreadCrumbs([
        { name: "Home", link: "/" },
        { name: "Payroll", link: "/Payroll" },
      ])
    );
  }, []);

  return (
    <div className="grid grid-cols-5 gap-2">
      <div className="col-span-3">
        <Widget heading={"Payroll Summary"}>
          <div className="h-full w-[50%]  mx-auto">
          </div>
        </Widget>
      </div>
      <div className="col-span-2 h-40">
        <Widget heading={"Payroll Status"}>
          <div className="text-center text-5xl">
            8
          </div>
        </Widget>
      </div>
      <div className="col-span-5">
        <Widget heading={'Staff Payroll Summary'}>
            Staff Payroll Summary
        </Widget>
      </div>
    </div>
  );
}
